const fadeClass = 'lazy-image';
const loadedClass = 'lazy-image--loaded';
const enhancedFlag = 'lazyImageEnhanced';
const skipLazySelector = '.header-logo__image, [data-lazy-eager]';

const markAsLoaded = (image) => {
  image.classList.add(loadedClass);
};

const attachLoadEvents = (image) => {
  const handleLoad = () => markAsLoaded(image);
  image.addEventListener('load', handleLoad, { once: true });
  image.addEventListener('error', handleLoad, { once: true });
};

const enhanceImage = (image) => {
  if (image.dataset[enhancedFlag] === 'true') {
    return;
  }

  image.dataset[enhancedFlag] = 'true';

  const shouldForceLazy = !image.matches(skipLazySelector);

  if (shouldForceLazy && image.getAttribute('loading') !== 'lazy') {
    image.setAttribute('loading', 'lazy');
  }

  if (!shouldForceLazy && image.getAttribute('loading') === 'lazy') {
    image.removeAttribute('loading');
  }

  image.classList.add(fadeClass);

  if (image.complete && image.naturalWidth !== 0) {
    requestAnimationFrame(() => markAsLoaded(image));
  } else {
    attachLoadEvents(image);
  }
};

const enhanceImagesWithin = (root) => {
  root.querySelectorAll('img').forEach(enhanceImage);
};

enhanceImagesWithin(document);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) {
        continue;
      }

      if (node.tagName === 'IMG') {
        enhanceImage(node);
        continue;
      }

      enhanceImagesWithin(node);
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });